/* BAF Saat — koleksiyon: filtre paneli (mobil alt sayfa), anlık filtre gönderimi, sıralama, "Daha fazla yükle". */
(() => {
  const kok = document.querySelector('[data-bs-koleksiyon]');
  if (!kok) return;
  const panel = kok.querySelector('[data-bs-filtre]');
  const form = kok.querySelector('[data-bs-filtre-form]');

  /* Boş fiyat alanlarını URL'e koyma */
  const gonder = () => {
    const veri = new FormData(form);
    const p = new URLSearchParams();
    for (const [k, v] of veri) if (String(v).trim() !== '') p.append(k, v);
    window.location.href = `${form.action}?${p.toString()}`;
  };

  kok.querySelector('[data-bs-filtre-ac]')?.addEventListener('click', () => panel.showModal());
  kok.querySelector('[data-bs-filtre-kapat]')?.addEventListener('click', () => panel.close());
  panel?.addEventListener('click', (e) => { if (e.target === panel) panel.close(); });

  /* Seçimler çekmecedeki "Sonuçları göster" ile uygulanır (revizyon 2: masaüstünde de çekmece) */
  form?.addEventListener('submit', (e) => { e.preventDefault(); gonder(); });
  kok.querySelector('[data-bs-sirala]')?.addEventListener('change', gonder);

  /* Uzun listelerde (marka) arama */
  kok.querySelectorAll('[data-bs-filtre-ara]').forEach((alan) => {
    alan.addEventListener('input', () => {
      const q = alan.value.trim().toLocaleLowerCase('tr-TR');
      alan.nextElementSibling.querySelectorAll('li').forEach((li) => {
        li.hidden = q && !li.textContent.toLocaleLowerCase('tr-TR').includes(q);
      });
    });
  });

  /* Daha fazla yükle: sonraki sayfayı bölüm olarak getir, kartları ekle */
  kok.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-bs-daha-fazla]');
    if (!btn) return;
    e.preventDefault();
    btn.setAttribute('aria-busy', 'true');
    try {
      const url = new URL(btn.href, location.origin);
      url.searchParams.set('section_id', kok.dataset.bolum);
      const html = await fetch(url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const yeni = doc.querySelectorAll('[data-bs-izgara] > li');
      const izgara = kok.querySelector('[data-bs-izgara]');
      yeni.forEach((li) => izgara.appendChild(li));
      const yeniDevam = doc.querySelector('.bs-kol-devam');
      const devam = kok.querySelector('.bs-kol-devam');
      if (yeniDevam) devam.replaceWith(yeniDevam);
      else devam.remove();
      history.replaceState(null, '', btn.href);
      window.bsHareketHazirla?.(izgara);
    } catch (err) {
      window.location.href = btn.href;
    }
  });
})();
